export default "__VITE_ASSET__t7EIG9No__"